export default __webpack_public_path__ + "static/media/image-recharge-not-available.f88256c3.svg";